import request, { ResponseData, PagerData } from '@/libs/request/request'
import { SpouseQuery } from 'src/api/spouse/SpouseQuery'
import { User } from 'src/api/user/User'

// Spouse
export type Spouse = {

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 业务Id
  id?:number

  // 是否丧偶
  isBereave?:number

  // 是否离异
  isDivorce?:number

  // 轮播图场景名称
  name?:string

  // 图片(上传路径)
  picture?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 用户id
  userId?:number

  // 标题
  version?:number

  // 性别 1:男 2:女
  gender?:number

  // 族谱成员id
  genealogyMemberId?:number

  // 手机号
  phone?:string

  // 用户
  user?:User

  // 出生时间}
  birth?:string

  // 死亡时间}
  death?:string

  // 是否过世
  isDie?:number

  // 备注
  remarks?:string
}

export default class SpouseService {
  /**
   * 添加一个配偶
   * @param {Spouse} item 配偶实体
   **/
  static addOneSpouse (item?:Spouse):Promise<ResponseData<Spouse>> {
    return request<ResponseData<Spouse>>({
      method: 'POST',
      data: item,
      url: '/admin/Spouse/Spouse'
    })
  }

  /**
   * 更新一个配偶
   * @param {Spouse} item 配偶实体
   **/
  static updateOneSpouse (item?:Spouse):Promise<ResponseData<Spouse>> {
    return request<ResponseData<Spouse>>({
      method: 'PUT',
      data: item,
      url: '/admin/Spouse/Spouse'
    })
  }

  /**
   * 获取配偶的分页数据
   * @param {SpouseQuery} query 配偶实体查询条件
   **/
  static getPagesOfSpouse (query?:SpouseQuery):Promise<ResponseData<PagerData<Spouse>>> {
    return request<ResponseData<PagerData<Spouse>>>({
      method: 'POST',
      data: query,
      url: '/admin/Spouse/Spouse/pages'
    })
  }

  /**
   * 通过id获取一个配偶
   * @param {number} id 配偶id
   **/
  static getOneSpouse (id:number):Promise<ResponseData<Spouse>> {
    return request<ResponseData<Spouse>>({
      method: 'GET',
      url: `/admin/Spouse/Spouse/${id}`
    })
  }

  /**
   * 删除一个配偶
   * @param {number} id 配偶id
   **/
  static deleteOneSpouse (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/Spouse/Spouse/${id}`
    })
  }
}
